import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Identifiers } from '../index';
import Storage from '../storage';
import { uuidv4 } from './util';
var Anonymous = /*#__PURE__*/function () {
  function Anonymous() {
    _classCallCheck(this, Anonymous);
  }
  _createClass(Anonymous, null, [{
    key: "processAnonymousUser",
    value: function processAnonymousUser(featureFlagUser) {
      var identifier = featureFlagUser.identifier;
      if (identifier) {
        return _objectSpread(_objectSpread({}, featureFlagUser), {}, {
          identifier: identifier
        });
      }
      identifier = {
        type: Identifiers.FF_CLIENT_ANONYMOUS_ID,
        value: Anonymous.generateAnonymousId()
      };
      return _objectSpread(_objectSpread({}, featureFlagUser), {}, {
        isAnonymous: true,
        identifier: identifier
      });
    }
  }, {
    key: "generateAnonymousId",
    value: function generateAnonymousId() {
      var storedAnonymousId = Storage.getAnonymousId();
      if (storedAnonymousId) {
        return storedAnonymousId;
      }
      var anonymousId = uuidv4();
      Storage.setAnonymousId(anonymousId);
      return anonymousId;
    }
  }]);
  return Anonymous;
}();
export { Anonymous as default };